import { parseDate } from './utils'

export default class ProcessChangesHistory {
	static fromJSON(json) {
		if (!json) return null
		const appointment = new ProcessChangesHistory(json.id)
			.withAppointmentId(json.appointmentId)
			.withRequisitionId(json.requisitionId)
			.withModificationUser(json.modificationUser)
			.withModificationDate(json.modificationDate)
			.withInjuredState(json.injuredState)
			.withClinicalState(json.clinicalState)
			.withEntity(json.entity)
			.withObservations(json.observations)

		return appointment
	}

	constructor(id) {
		this.id = id
		this.textId = `history_${id || ''}`
		this.key = this.textId
	}

	withAppointmentId(appointmentId) {
		this.appointmentId = appointmentId
		return this
	}

	withRequisitionId(requisitionId) {
		this.requisitionId = requisitionId
		return this
	}

	withModificationUser(modificationUser) {
		this.modificationUser = modificationUser?.name
		return this
	}

	withModificationDate(dateStr) {
		this.modificationDate = parseDate(dateStr)
		return this
	}

	withInjuredState(injuredState) {
		this.injuredState = injuredState?.name
		return this
	}

	withClinicalState(clinicalState) {
		this.clinicalState = clinicalState
		return this
	}

	withEntity(entity) {
		this.entity = entity?.name
		return this
	}

	withObservations(observations) {
		this.observations = observations
		this.text = observations
		return this
	}
}
